import { EPromoDetailsActionTypes } from '../../actions/promoDetails';
import { TReduxActions } from '../../types/redux';
import { IPromoDetailsState } from '../../types/redux/promoDetails';

export const defaultState: IPromoDetailsState = {
  isOpenModal: false,
  currentPromoId: null,
};

export function promoDetailsReducer(
  state: IPromoDetailsState = defaultState,
  action: TReduxActions,
): IPromoDetailsState {
  switch (action.type) {
    case EPromoDetailsActionTypes.OpenDetails:
      return {
        ...state,
        isOpenModal: true,
        currentPromoId: action.payload,
      };

    case EPromoDetailsActionTypes.CloseDetails:
      return {
        ...state,
        isOpenModal: false,
        currentPromoId: null,
      };

    default:
      return state;
  }
}
